import { ROUTES } from "api";

import { baseApi } from "../baseAPI";

const passportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    validatePassport: builder.mutation({
      queryFn: async (scanData, _queryApi, _extraOptions, fetchWithBQ) => {
        try {
          const result = await fetchWithBQ({
            url: ROUTES.validatePassport,
            method: "POST",
            body: scanData,
          });

          if (result?.error) {
            const title =
              result.error?.status === 400
                ? result.error?.data?.message?.includes(
                    "Profile Does Not exist"
                  )
                  ? "Profile does not exist or the sent data is invalid. Please try again"
                  : result.error?.status
                : result.error?.status;

            return {
              data: {
                status: "error",
                message: "An error occurred while validating the passport.",
                title,
                messageLong: `An error occurred while validating the passport. 
                  Request Error:
                  ${JSON.stringify(
                    result.error?.status === 400
                      ? result.error?.data?.message
                      : result.error?.data
                  )}
                  Sent data:
                  ${JSON.stringify(scanData)}
                  `,
              },
            };
          }

          return {
            data: {
              status: "success",
              data: {
                result: result.data?.data?.result ?? false,
              },
            },
          };
        } catch (error) {
          return {
            error: {
              status: "error",
              message: "An error occurred while processing your request",
            },
          };
        }
      },
    }),
  }),
});

export const { useValidatePassportMutation } = passportApi;
